





























































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import SingleChoiceAnswer from "@/components/SingleChoiceAnswer.vue";
import MultipleChoiceAnswer from "@/components/MultipleChoiceAnswer.vue";
import TextAnswer from "@/components/TextAnswer.vue";
import EditorAnswer from "@/components/EditorAnswer.vue";
import DateAnswer from "@/components/DateAnswer.vue";
import TimeAnswer from "@/components/TimeAnswer.vue";
import DateTimeAnswer from "@/components/DateTimeAnswer.vue";
import SelectPopover from "@/components/SelectPopover.vue";
import { CaseRecord, Form, FormQuestion } from "@/store/modules/types";
@Component({
  components: {
    SingleChoiceAnswer,
    MultipleChoiceAnswer,
    TextAnswer,
    EditorAnswer,
    DateAnswer,
    TimeAnswer,
    DateTimeAnswer,
    SelectPopover,
  },
})
export default class CaseForm extends Vue {
  @Prop(String) readonly tabId!: string;
  @Prop() readonly caseRecord!: CaseRecord;
  @Prop() readonly form!: Form;
  @Prop() readonly formQuestions!: Array<FormQuestion>;
  @Prop() readonly formWizard!: Array<FormQuestion>;
  questions = Array<FormQuestion>();
  prevIndex = 0;
  currIndex = 0;
  @Watch("questions", { deep: true })
  onQuestionsChanged() {
    const { tabId } = this;
    const questions = JSON.parse(JSON.stringify(this.questions));
    this.$store.commit("cases/SET_TAB_CASE_FORM_QUESTIONS", {
      tabId,
      questions,
    });
    this.saved = false;
  }
  saved = false;
  lastSave = "";
  answer(questionId: number, value: string, jumpToKey: string) {
    if (this.formWizard) {
      const { answer } = this.question;
      answer.value = value;
      answer.jumpToKey = jumpToKey;
    } else {
      const question = this.questions.find((q) => q.id === questionId);
      if (question) question.answer.value = value;
    }
  }
  back() {
    this.currIndex = this.prevIndex;
  }
  next() {
    const { answer } = this.question;
    if (this.question.isOptional || answer.value) {
      this.prevIndex = this.currIndex;
      if (answer.jumpToKey) {
        this.currIndex = this.questions.findIndex(
          (q) => q.key === answer.jumpToKey
        );
      } else {
        this.currIndex += 1;
      }
    }
  }
  gotoQuestion(id: string) {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView();
  }
  gotoLastAnswer() {
    const id = this.answers[this.answers.length - 1].questionId;
    this.currIndex = this.questions.findIndex((q) => q.id === id);
  }
  async save(close: boolean) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { answers } = this;
      await this.$store.dispatch("cases/saveFormAnswers", {
        caseId: this.caseRecord.id,
        formId: this.form.id,
        answers,
      });
      this.$nextTick(() => {
        this.lastSave = this.$moment().format();
        this.saved = true;
        if (close) this.close();
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  close() {
    if (this.saved) {
      this.$store.commit("cases/REMOVE_TAB", this.tabId);
    } else {
      this.$modal.show("dialog", {
        title: "Close Tab",
        text: "There are unsaved changes. Are you sure?",
        buttons: [
          {
            title: "Yes",
            handler: () => {
              this.$store.commit("cases/REMOVE_TAB", this.tabId);
              this.$modal.hide("dialog");
            },
          },
          {
            title: "No",
            default: true,
          },
        ],
      });
    }
  }
  get question(): FormQuestion {
    return this.questions[this.currIndex];
  }
  get answers() {
    return this.questions
      .filter((q) => q.answer.value)
      .map((q) => {
        return {
          questionId: q.id,
          answer: q.answer.value,
        };
      });
  }
  mounted() {
    if (this.formQuestions) {
      this.questions = JSON.parse(JSON.stringify(this.formQuestions));
    }
  }
}
